import { createKeyFactory } from '@clouway/query'

export const sessionKeys = createKeyFactory('session')

export const userInfoKey = () => sessionKeys.custom('userinfo')
